import React, { Component } from 'react'
import { connect } from "react-redux"
import { Redirect } from 'react-router-dom'
import { getFirestore } from 'redux-firestore'
import { sortableContainer, sortableElement } from 'react-sortable-hoc';
import { ChromePicker } from 'react-color';
import { rgba2hex, getRectangleContactDesignedButton } from '../../../../Utils/UtilMethods'
import { AlertOkCancelComponent } from '../../../AlertsComponents/AlertsComponent'
import TopGlobalCustomButtonsColor from '../RoundedButtons/TopGlobalCustomButtonsColor'
import FontListSelectComponent from '../../FontListSelectComponent'
import LanguageSelectDropDownComponent from '../../LanguageSelectDropDownComponent'
import arrayMove from 'array-move';
import NumberStepperComponent from '../../NumberStepperComponent';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux'
import { TextEditor } from '../../../InputComponents/joditEditor';

export class EditRectangleContactButtons extends Component {

    selectedIndexToDelete = -1
    alertTitle = ""
    alertSubTitle = ""

    SortableContainer = sortableContainer(({ children }) => {
        return <ul >{children}</ul>;
    });

    SortableItem = sortableElement(({ value, myIndex }) => this.getRectangleButtonEditCard(value, myIndex));

    state = {
        ...this.props,
        didMakeChange: false,
        isUploadingNow: false,
        showingAlert: false,
        disableSorting: true,
        colorPicker: {
            lastSelectedColor: "#fff",
            isOpen: false,
            openInIndex: -1,
            targetId: ""
        },
    }

    componentWillReceiveProps(np) {
        if (np) {
            this.setState({
                ...this.state,
                rectangleButtons: np.rectangleButtons,
            })
        }
    }

    componentDidMount() {
        const M = window.M;
        var elems = document.querySelector('.create-card-select-language');
        M.FormSelect.init(elems, {});
        M.updateTextFields();
    }

    handleChangeForBlock = (e) => {

        this.setState({
            rectangleButtons: {
                ...this.state.rectangleButtons,
                [e.target.id]: e.target.value
            },

            didMakeChange: true
        });

    }

    handleChangeForItemInList = (e, index) => {
        console.log("handleChangeForItemInList : id %s value %s index %s", e.target.id, e.target.value, index);
        // 1. Make a shallow copy of the items
        let listCopy = [...this.state.rectangleButtons.list];
        // 2. Make a shallow copy of the item you want to mutate
        let item = { ...listCopy[index] };
        // 3. Replace the property you're intested in

        item = {
            ...item,
            [e.target.id]: e.target.value
        }
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        listCopy[index] = item;
        // 5. Set the state to our new copy

        // this.setState({ list: listCopy });
        this.setState({
            rectangleButtons: { ...this.state.rectangleButtons, list: listCopy },
            didMakeChange: true
        });
        console.log("the list is ", listCopy);
    }


    handleChangeFor_All_ItemInList = (e) => {
        // this.saveLastGlobalSelectionForRectangle(e)
        console.log("handleChangeForItemInList : id %s value %s index %s", e.target.id, e.target.value);
        // 1. Make a shallow copy of the items
        if (this.state.rectangleButtons) {
            let listCopy = [...this.state.rectangleButtons.list];

            for (let index = 0; index < listCopy.length; index++) {
                var item = listCopy[index];
                item = {
                    ...item,
                    [e.target.id]: e.target.value
                }
                listCopy[index] = item
            }

            this.setState({
                rectangleButtons: {
                    ...this.state.rectangleButtons,
                    lastGlobalSelections: {
                        ...this.state.rectangleButtons.lastGlobalSelections,
                        [e.target.id]: e.target.value
                    },
                    list: listCopy
                },
                didMakeChange: true
            });
        }
    }

    addNewItemInList = (button) => {
        // 1. Make a shallow copy of the items
        var listCopy = [];
        if (!this.state.rectangleButtons) {
            listCopy = [button];
        }
        else {
            listCopy = [button, ...this.state.rectangleButtons.list];
        }

        // 2. Make a shallow copy of the item you want to mutate        
        this.setState({
            rectangleButtons: { ...this.state.rectangleButtons, list: listCopy },
            didMakeChange: true
        });
    }

    deleteButton(index) {
        var array = [...this.state.rectangleButtons.list];
        var buttonsClickDictionary = this.state.rectangleButtons.buttonsClicks
        if (!buttonsClickDictionary) {
            buttonsClickDictionary = {}
        }
        var selectedButtonToDeleteId = this.state.rectangleButtons.list[index].id
        // delete the button click info for delete button
        if (buttonsClickDictionary[selectedButtonToDeleteId]) {
            delete buttonsClickDictionary[selectedButtonToDeleteId]
        }
        array.splice(index, 1);
        var newRectangleDict = {
            ...this.state.rectangleButtons,
            list: array,
            buttonsClicks: buttonsClickDictionary,
        }

        this.setState(
            {
                rectangleButtons: newRectangleDict
            });
        this.saveChanges(newRectangleDict);
    }

    saveChanges = (object) => {
        var sendValue = object ? object : this.state.rectangleButtons
        this.setState({
            isUploadingNow: true,
            // disableSorting: true
        });

        const firestore = getFirestore();
        firestore.collection('cards').doc(this.props.cardID).set({
            "rectangleButtons": sendValue,

        }, { merge: true }).then(() => {
            console.log("succes in dispatch");
            this.props.updateReduxRectangleList(this.state.rectangleButtons)
            this.setState({
                didMakeChange: false,
                isUploadingNow: false
            });

        }).catch(err => {
            console.log("error in dispatch");
            this.setState({
                didMakeChange: false,
                isUploadingNow: false
            });
        });
    }

    // color picker
    handlePickerChangeComplete = (color) => {
        console.log(" handlePickerChangeComplete", color.hex);
    };

    handlePickerChange = (name) => (color) => {
        var hex = "#" + rgba2hex(`rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a},)`)
        this.handleChangeForItemInList(
            {
                target:
                {
                    id: this.state.colorPicker.targetId,
                    value: hex
                }
            }, this.state.colorPicker.openInIndex)
        this.setState({ colorPicker: { ...this.state.colorPicker, lastSelectedColor: hex } });
    }

    handlePickerOpen = (color, index, targetName, e) => {
        e.preventDefault()
        this.setState({
            colorPicker:
            {
                isOpen: true,
                lastSelectedColor: color,
                openInIndex: index,
                targetId: targetName
            }
        }
        );
    }

    handlePickerClose = () => {
        this.setState({
            colorPicker:
            {
                isOpen: false,
                lastSelectedColor: "",
                openInIndex: -1,
                targetId: ""
            }
        }
        );
    }

    showDeleteAlert(e, buttonIndex) {
        e.preventDefault()
        this.selectedIndexToDelete = buttonIndex
        this.alertTitle = this.props.t("DeleteButton?")
        this.alertSubTitle = this.props.t("SureDelete?")
        this.setState({
            showingAlert: true
        })
    }

    render() {
        const popover = {
            position: 'fixed',
            zIndex: '2',
        }
        const cover = {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
        }

        const bootomFixedForUpdateButton = {
            position: 'fixed',
            zIndex: '2',
            backgroundColor: "red",
            height: "40px",
            right: '0px',
            bottom: '0px',
            left: '0px',
        }

        const { i18n, t, auth, cardID } = this.props;
        if (!auth.uid) return <Redirect to='/' />
        return (
            <div className="container" style={{ marginBottom: "45px" }}>

                {this.state.showingAlert ?
                    < AlertOkCancelComponent title={this.alertTitle} subtitle={this.alertSubTitle} closeAlert={(confirm) => {

                        if (confirm) {
                            this.deleteButton(this.selectedIndexToDelete)
                        }

                        this.setState({
                            showingAlert: false
                        })
                    }} />
                    : null}

                {this.state.colorPicker.isOpen ? <div style={popover}>
                    <div style={cover} onClick={this.handlePickerClose} />
                    <ChromePicker
                        color={this.state.colorPicker.lastSelectedColor}
                        onChangeComplete={this.handlePickerChangeComplete}
                        onChange={this.handlePickerChange("color")} />
                </div> : null}

                <div>
                    <TopGlobalCustomButtonsColor
                        marginTopBlockValue={this.state.rectangleButtons.marginTopBlock ? this.state.rectangleButtons.marginTopBlock : 0}
                        isForRectangle={true}
                        setAllWithData={(data) => {
                            console.log("sent data", data);
                            this.handleChangeFor_All_ItemInList(data)
                        }}
                        newButton={button => {
                            this.addNewItemInList(button)
                        }}
                        enterSortMode={checked => {
                            this.setState({
                                ...this.state,
                                disableSorting: !checked
                            })
                        }}

                        marginTopBlock={(value) => {
                            this.handleChangeForBlock(value)
                        }}

                        lastGlobalSelections={this.state.rectangleButtons.lastGlobalSelections}
                    />


                    {this.state.didMakeChange ?
                        <div style={bootomFixedForUpdateButton}>
                            <button className={"btn btnUpdateServer z-depth-0 fullWidth  " + (this.state.didMakeChange ? "" : "disabled")} onClick={() => this.saveChanges(null)} >{t("SaveChanges")}
                                <i className={(this.state.isUploadingNow ? "fa fa-refresh fa-spin" : "")} style={{ marginLeft: 10 }} ></i>
                            </button>
                        </div> : null}

                    <this.SortableContainer onSortEnd={this.onSortEnd} >
                        {this.state.rectangleButtons && this.state.rectangleButtons.list.map((value, index) => (
                            <this.SortableItem key={`item-${index}`} index={index} value={value} myIndex={index} disabled={this.state.disableSorting} />
                        ))}
                    </this.SortableContainer>

                </div>

            </div>

        )
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        var myList = [...this.state.rectangleButtons.list];
        var newList = arrayMove(myList, oldIndex, newIndex)
        this.setState({
            rectangleButtons: { ...this.state.rectangleButtons, list: newList },
            didMakeChange: true
        });
    };

    getEditCardTopOptionsBar(button, index) {
        return (
            <div className="center">
                <div style={{ marginBottom: 10 }}>
                    {getRectangleContactDesignedButton(button, () => { }, this.props.cardID)}
                </div>
                <div className="roundedButtons">
                    <ul>
                        <li>
                            <NumberStepperComponent
                                value={button.borderWidth}
                                max={20}
                                min={0}
                                step={1}
                                title={this.props.t("BorderWidth")}
                                didMakeChange={(value) => {
                                    let newValue = {
                                        target: {
                                            id: "borderWidth",
                                            value: value
                                        }
                                    }
                                    this.handleChangeForItemInList(newValue, index)
                                }} />
                        </li>
                        <li>
                            <NumberStepperComponent
                                value={button.fontSize}
                                max={60}
                                min={10}
                                step={1}
                                title={this.props.t("FontSize")}
                                didMakeChange={(value) => {
                                    let newValue = {
                                        target: {
                                            id: "fontSize",
                                            value: value
                                        }
                                    }
                                    this.handleChangeForItemInList(newValue, index)
                                }} />
                        </li>
                        <li style={{ width: "50px" }}>
                            <div style={{ width: "50px" }}>
                                <FontListSelectComponent fontName={button.fontName} selectedFont={(fontName) => {
                                    console.log("font selected");

                                    let value = {
                                        target: {
                                            id: "fontName",
                                            value: fontName
                                        }
                                    }
                                    this.handleChangeForItemInList(value, index)
                                }} />
                            </div>
                        </li>
                        {this.getCutomizeButtons("fa fa-paint-brush", button.color, index, "color")}
                        {this.getCutomizeButtons("fa fa-paint-brush", button.borderColor, index, "borderColor")}
                        {this.getCutomizeButtons("fa fa-paint-brush", button.iconColor, index, "iconColor")}
                        {this.getCutomizeButtons("fa fa-paint-brush", button.textColor, index, "textColor")}

                        {this.getDesignedDeleteButton(index)}
                    </ul>
                </div>
            </div>


        )
    }

    getRectangleButtonEditCard(button, index) {
        // imported react for this //
        console.log("the button is:", button);
        const liStyle = {
            listStyleType: "none",
        }

        const cardStyle = {
            border: this.state.disableSorting ? "0px solid" : "3px solid",
            borderColor: "red",
        }

        switch (button.type) {
            case 'tel':
                return (
                    <li key={`item-${index}`} style={{ listStyleType: "none" }} >
                        <div className="edit_button_card_container " style={cardStyle}>

                            {this.getEditCardTopOptionsBar(button, index)}


                            <div >
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("ButtonTitle")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='title' placeholder={this.props.t("ButtonTitle")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.title} />
                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto">{this.props.t("WillCall")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="number" id='number' placeholder={this.props.t("EnterAnyPhone")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.number} />
                            </div>
                            <div className="edit_button_card_title" dir="auto"> {this.props.t("Index")} {index} {this.props.t("ButtonTitle")} {button.type}</div>
                        </div>

                    </li>
                )
            case 'whatsApp':
                return (
                    <li key={`item-${index}`} style={{ listStyleType: "none" }} >
                        <div className="edit_button_card_container " style={cardStyle}>

                            {this.getEditCardTopOptionsBar(button, index)}


                            <div >
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("ButtonTitle")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='title' placeholder={this.props.t("ButtonTitle")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.title} />
                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto">{this.props.t("WillOpenChat")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="number" id='number' placeholder={this.props.t("PhoneWithCountry")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.number} />
                            </div>
                            <div className="edit_button_card_title" dir="auto"> {this.props.t("Index")} {index} {this.props.t("ButtonTitle")} {button.type}</div>
                        </div>

                    </li>
                )
            case 'sms':
                return (
                    <li key={`item-${index}`} style={{ listStyleType: "none" }} >
                        <div className="edit_button_card_container " style={cardStyle}>

                            {this.getEditCardTopOptionsBar(button, index)}


                            <div >
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("ButtonTitle")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='title' placeholder={this.props.t("ButtonTitle")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.title} />
                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto">{this.props.t("WillSendSms")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="number" id='number' placeholder={this.props.t("EnterAnyPhone")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.number} />
                            </div>
                            <div className="edit_button_card_title" dir="auto"> {this.props.t("Index")} {index} {this.props.t("ButtonTitle")} {button.type}</div>
                        </div>

                    </li>
                )

            case 'mailto':
                return (
                    <li key={`item-${index}`} style={liStyle}>
                        <div className="edit_button_card_container " style={cardStyle}>
                            {this.getEditCardTopOptionsBar(button, index)}

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("ButtonTitle")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='title' placeholder={this.props.t("ButtonTitle")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.title} />

                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("WillOpenEmail")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="email" id='mail' placeholder={this.props.t("EnterE-Mail")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.mail} />
                            </div>
                            <div className="edit_button_card_title" dir="auto"> {this.props.t("Index")} {index} {this.props.t("ButtonTitle")} {button.type}</div>
                        </div>
                    </li>
                )

            case 'contact':
                return (
                    <li key={`item-${index}`} style={liStyle}>
                        <div className="edit_button_card_container " style={cardStyle}>
                            {this.getEditCardTopOptionsBar(button, index)}

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("ButtonTitle")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='title' placeholder={this.props.t("ButtonTitle")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.title} />
                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("VCardTitle")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='contactTitle' placeholder={this.props.t("VCardTitle")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.contactTitle} />
                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("ButtonTitle")}{this.props.t("FirstName")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='firstName' placeholder={this.props.t("FirstName")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.firstName} />
                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("ButtonTitle")}{this.props.t("lName")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='lastName' placeholder={this.props.t("lName")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.lastName} />
                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("ButtonTitle")}{this.props.t("PhoneNumber")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='cellNumber' placeholder={this.props.t("EnterAnyPhone")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.cellNumber} />
                            </div>

                            <div className="input-field">

                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("ButtonTitle")}{this.props.t("Email")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="email" id='email' placeholder={this.props.t("Email")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.email} />
                            </div>
                            <div className="edit_button_card_title" dir="auto"> {this.props.t("Index")} {index} {this.props.t("ButtonTitle")} {button.type}</div>
                        </div>
                    </li>

                )
            case 'link':
                return (
                    <li key={`item-${index}`} style={liStyle}>
                        <div className="edit_button_card_container " style={cardStyle}>
                            {this.getEditCardTopOptionsBar(button, index)}

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("ButtonTitle")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='title' placeholder={this.props.t("ButtonTitle")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.title} />
                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("WillOpenBrowser")}</div>
                                {
                                    console.log("button.url", button.url, index)

                                }
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='url' placeholder="Enter web site like www.udisapp.com" onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.url} />
                            </div>
                            <div className="edit_button_card_title" dir="auto"> {this.props.t("Index")} {index} {this.props.t("ButtonTitle")} {button.type}</div>
                        </div>
                    </li>

                )

            case 'waze':
                return (
                    <li key={`item-${index}`} style={liStyle}>
                        <div className="edit_button_card_container " style={cardStyle}>
                            {this.getEditCardTopOptionsBar(button, index)}

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("ButtonTitle")}</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='title' placeholder={this.props.t("ButtonTitle")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.title} />
                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("City")}</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='city' placeholder={this.props.t("City")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.city} />
                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("Address")}</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='address' placeholder={this.props.t("Address")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.address} />
                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  ><a href="https://www.waze.com/livemap"> {this.props.t("Waze.comPath")}</a></div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='wazePath' placeholder={this.props.t("Waze.comPath")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.wazePath} />
                            </div>
                            <div className="edit_button_card_title" dir="auto"> {this.props.t("Index")} {index} {this.props.t("Type")} {button.type}</div>
                        </div>
                    </li>
                )

            case 'contactForm':
                return (
                    <li key={`item-${index}`} style={liStyle}>
                        <div className="edit_button_card_container " style={cardStyle}>
                            {this.getEditCardTopOptionsBar(button, index)}

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("ButtonTitle")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='title' placeholder={this.props.t("ButtonTitle")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.title} />
                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("WillSendE_Mail")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="email" id='mail' placeholder={this.props.t("EnterE-Mail")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.mail} />
                            </div>

                            <div className="edit_button_card_subtitle" dir="auto"  >

                                <LanguageSelectDropDownComponent formLanguage={button.formLanguage} selectedLanguage={(language) => {
                                    let value = {
                                        target: {
                                            id: "formLanguage",
                                            value: language
                                        }
                                    }
                                    this.handleChangeForItemInList(value, index)
                                }} />


                            </div>
                            <div className="edit_button_card_title" dir="auto"> Index {index} Type {button.type}</div>
                        </div>
                    </li>
                )

            case 'about':
                return (
                    <li key={`item-${index}`} style={liStyle}>
                        <div className="edit_button_card_container " style={cardStyle}>
                            {this.getEditCardTopOptionsBar(button, index)}

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("ButtonTitle")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='title' placeholder={this.props.t("ButtonTitle")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.title} />

                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("Title")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='aboutTitle' placeholder={this.props.t("AddTitle")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.aboutTitle} />
                            </div>

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >{this.props.t("Description")}:</div>
                                <textarea dir="auto"
                                    className="browser-default edit_button_card_input"
                                    type="text" id='aboutText' dir="auto"
                                    placeholder={this.props.t("AddDescription")}
                                    style={{ height: 60 }}
                                    onChange={(e) => this.handleChangeForItemInList(e, index)}
                                    value={button.aboutText} />
                            </div>
                            <div className="edit_button_card_title" dir="auto"> {this.props.t("Index")} {index} {this.props.t("Type")} {button.type}</div>
                        </div>
                    </li>
                )

            case 'about_custom':
                return (
                    <li key={`item-${index}`} style={liStyle}>
                        <div className="edit_button_card_container " style={cardStyle}>
                            {this.getEditCardTopOptionsBar(button, index)}

                            <div className="input-field">
                                <div className="edit_button_card_subtitle" dir="auto"  >
                                    {this.props.t("ButtonTitle")}:</div>
                                <input dir="auto" className="browser-default edit_button_card_input" type="text" id='title' placeholder={this.props.t("ButtonTitle")} onChange={(e) => this.handleChangeForItemInList(e, index)} value={button.title} />

                            </div>

                            <TextEditor
                                text={button.text}
                                handleChange={(value) => {
                                    var val = {
                                        target: {
                                            id: "text",
                                            value: value
                                        }
                                    }
                                    this.handleChangeForItemInList(val, index)
                                }}
                            />

                            <div className="edit_button_card_title" dir="auto"> {this.props.t("Index")} {index} {this.props.t("Type")} {button.type}</div>
                        </div>
                    </li>
                )

            default:
                return null;
        }
    }

    getDesignedDeleteButton(buttonIndex) {

        var style = {
            backgroundColor: "white",
            width: "34px",
            height: "34px",
            border: "2px solid",
            borderColor: "red"
        }
        return (
            <li style={{ width: "50px", padding: "2px" }}>
                <div style={{ width: "50px" }}>
                    <a href="#"
                        className="btn-floating btn waves-effect waves-light "
                        style={style}
                        onClick={(e) => this.showDeleteAlert(e, buttonIndex)}
                    >
                        <i className="fa fa-trash-o iconCenter" aria-hidden="true"
                            style={{ color: "red", fontSize: "16px" }}></i>
                    </a>
                    <br />
                    <span className="center" style={{ color: "black", }}></span>
                    <span style={{ fontSize: "12px", style: "bold", color: "red", display: "block", marginTop: "4px" }}>{this.props.t("Delete")}</span>
                </div>
            </li>
        )
    }


    getCutomizeButtons(iconName, color, index, targetName) {
        var style = {
            backgroundColor: color,
            width: "38px",
            height: "38px",

        }

        var description = ""

        switch (targetName) {
            case 'color':
                description = this.props.t('Button')
                break;

            case 'iconColor':
                description = this.props.t("Icon")
                break;

            case 'borderColor':
                description = this.props.t('Border')
                break;

            case 'textColor':
                description = this.props.t('Text')
                break;

            default:
                break;
        }

        return (
            <li style={{ width: "50px", }}>
                <div style={{ width: "50px" }}>
                    <a href="#"
                        className="btn-floating btn waves-effect waves-light "
                        style={style}
                        onClick={(e) => this.handlePickerOpen(color, index, targetName, e)}
                    >
                        <i className={iconName + " iconCenter"} aria-hidden="true"
                            style={{ color: "white", fontSize: "16px" }}></i>
                    </a>
                    <br />

                    <span className="center" style={{ fontSize: "12px", color: "black", display: "block", marginTop: "4px" }}>{description}</span>
                </div>
            </li>

        )
    }

    getCenterDesignedButton(button) {
        var style = {
            backgroundColor: button.color,
            border: "2px solid",
            borderColor: button.borderColor,
            width: "38px",
            height: "38px",
        }
        switch (button.type) {
            case 'tel':
                return (
                    <div>
                        <a href={"tel:" + button.number}
                            className={button.shape + " waves-effect waves-light "}
                            style={style}
                        >
                            <i className={button.icon + " iconCenter"} aria-hidden="true"
                                style={{ color: button.iconColor, fontSize: "25px" }}></i>
                        </a>
                        <br />
                        <span style={{ fontSize: "8px", color: button.textColor, display: "block", marginTop: "4px" }}>{button.title}</span>
                    </div>
                )

            case "whatsApp":
                return (

                    <div  >
                        <a href={"https://api.whatsapp.com/send?phone=" + button.number}
                            className={button.shape + " waves-effect waves-light "}
                            style={style}
                        >
                            <i className={button.icon + " iconCenter"} aria-hidden="true"
                                style={{ color: button.iconColor, fontSize: "25px" }}></i>
                        </a>
                        <br />
                        <span style={{ fontSize: "8px", color: button.textColor, display: "block", marginTop: "4px" }}>{button.title}</span>
                    </div>

                )

            case "sms":
                return (
                    <div>
                        <a href={"sms:" + button.cellNumber}
                            className={button.shape + " waves-effect waves-light "}
                            style={style}
                        >
                            <i className={button.icon + " iconCenter"} aria-hidden="true"
                                style={{ color: button.iconColor, fontSize: "25px" }}></i>
                        </a>
                        <br />
                        <span style={{ fontSize: "8px", color: button.textColor, display: "block", marginTop: "4px" }}>{button.title}</span>
                    </div >

                )


            case "waze":
                return (

                    <div  >
                        <a href={"waze://?q=" + button.city + " " + button.address}
                            className={button.shape + " waves-effect waves-light "}
                            style={style}
                        >
                            <i className={button.icon + " iconCenter"} aria-hidden="true"
                                style={{ color: button.iconColor, fontSize: "25px" }}></i>
                        </a>
                        <br />
                        <span style={{ fontSize: "8px", color: button.textColor, display: "block", marginTop: "4px" }}>{button.title}</span>
                    </div>


                )

            case "mailto":
                return (

                    <div  >
                        <a href={"mailto:" + button.mail}
                            className={button.shape + " waves-effect waves-light "}
                            style={style}
                        >
                            <i className={button.icon + " iconCenter"} aria-hidden="true"
                                style={{ color: button.iconColor, fontSize: "25px" }}></i>
                        </a>
                        <br />
                        <span style={{ fontSize: "8px", color: button.textColor, display: "block", marginTop: "4px" }}>{button.title}</span>
                    </div>
                )

            case "contact":
                return (

                    <div  >
                        <a
                            className={button.shape + " waves-effect waves-light "}
                            style={style}
                        >
                            <i className={button.icon + " iconCenter"} aria-hidden="true"
                                style={{ color: button.iconColor, fontSize: "25px" }}></i>
                        </a>
                        <br />
                        <span style={{ fontSize: "8px", color: button.textColor, display: "block", marginTop: "4px" }}>{button.title}</span>
                    </div>


                )

            case "link":
                return (

                    <div  >
                        <a href={button.url}
                            className={button.shape + " waves-effect waves-light "}
                            style={style}
                        >
                            <i className={button.icon + " iconCenter"} aria-hidden="true"
                                style={{ color: button.iconColor, fontSize: "25px" }}></i>
                        </a>
                        <br />
                        <span style={{ fontSize: "8px", color: button.textColor, display: "block", marginTop: "4px" }}>{button.title}</span>
                    </div >

                )
            default:
                return null;
        }
    }

}


const mapDispatchToProps = (dispatch) => {
    return (
        {
            updateReduxRectangleList: (rectangleButtons) => { dispatch({ type: "UPDATE_RECTANGLE_LIST", rectangleButtons: rectangleButtons }) }
        })
}


const mapStateToProps = (state) => {
    console.log("state", state);
    return {
        auth: state.firebase.auth,
    }
}


export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(EditRectangleContactButtons)
